// extracted by mini-css-extract-plugin
export default {"columnaSimple":"DatosClub_columnaSimple__5z4cq"};